'use strict';

import template from './language_input.html';

const saLanguageInput = [
  'languages',

  function (languages) {
    return {
      template: template,
      replace: true,
      require: 'ngModel',
      scope: {},
      link: function ($scope, $element, $attr, ngModel) {
        var selectEl = $element.find('select');
        var $isEmpty = ngModel.$isEmpty;

        function blueHandler() {
          ngModel.$setTouched();
        }

        $scope.languages = languages;

        ngModel.$render = function () {
          $scope.selectedLanguages = ngModel.$modelValue || [];
        };

        ngModel.$isEmpty = function (value) {
          return $isEmpty(value) || angular.isArray(value) && !value.length;
        };

        $scope.$watch('selectedLanguages.length', function () {
          ngModel.$setViewValue(angular.copy($scope.selectedLanguages));
        });

        selectEl.on('blur', blueHandler);

        $scope.$on('$destroy', function () {
          selectEl.off('blur', blueHandler);
        });
      }
    };
  }
];

export default saLanguageInput;



// WEBPACK FOOTER //
// ./app/src/directives/language_input.js